import App from "./Components/App";
import Alpine from "alpinejs";

import { loader } from "./Components/Loader";
import { searchForm } from "./Components/SearchFrom";
import { miniCart } from "./Components/MiniCart";
import { productBundle } from "./Components/ProductBundle";
import { account } from "./Components/Account";
import { formBilling } from "./Components/FormBilling";
import { addToCart } from "./Components/AddToCart";
import { shipping } from "./Components/Shipping";
import { coupon } from "./Components/Coupon";
import { mobileMenu } from "./Components/MobileMenu";
import { compare } from "./Components/Compare";
import { priceFilter } from "./Components/PriceFilter";
import { wishlist } from "./Components/Wishlist";
import { cartProduct } from "./Components/CartProduct";
import { accountPage } from "./Components/AccountPage";
import { categoryFilter } from "./Components/CategoryFilter";
import { productGallery } from "./Components/ProductGallery";
import { judgeMe } from "./Components/JudgeMe";
import { juraPage } from "./Components/JuraPage";
import OrderBumps from "./Components/OrderBumps";
import Checkout from "./Components/Checkout";
import { scrollingHeader } from "./Components/Header";

// Safari back fix
window.addEventListener(
  "pageshow",
  function (event) {
    if (event.persisted) {
      window.location.reload();
    }
  },
  false
);

document.addEventListener("DOMContentLoaded", () => {
  loader();
  searchForm();
  miniCart();
  productBundle();
  account();
  formBilling();
  addToCart();
  shipping();
  coupon();
  mobileMenu();
  compare.init();
  priceFilter();
  wishlist();
  cartProduct();
  accountPage();
  categoryFilter();
  productGallery();
  judgeMe();
  juraPage();
  scrollingHeader();
  OrderBumps.init();
  Checkout.init();

  window.Alpine = Alpine;
  Alpine.start();
});
